import { CopilotScript } from '@coach-bot/data-access/shared/models';
import { captureException } from '@sentry/browser';
import { ServiceWorkerCommunicationService } from '@shared/extension/services/service-worker-communication.service';
import { withRetry } from '@shared/http/utils/with-retry';
import { ContentScriptStore } from '../store';

const GET_COPILOT_SCRIPTS_MAX_RETRY = 5;

export async function refreshCopilotScripts(
  serviceWorkerCommunicationService: ServiceWorkerCommunicationService,
  store: ContentScriptStore
): Promise<void> {
  try {
    const copilotScripts: CopilotScript[] = await withRetry(
      serviceWorkerCommunicationService.getCopilotScripts.bind(serviceWorkerCommunicationService),
      GET_COPILOT_SCRIPTS_MAX_RETRY
    );
    const filteredScripts = copilotScripts.filter(script =>
      shouldRunScript(script, store.learningApp$.value, store.profileEmail$.value)
    );
    const filteredScriptNames = filteredScripts.map(script => script.name);
    window.localStorage.setItem('copilotScripts', JSON.stringify(filteredScripts));
    console.log('Set copilot scripts to localStorage', JSON.stringify(filteredScriptNames));
  } catch (ex) {
    captureException(ex);
  }
}

function shouldRunScript(script: CopilotScript, app: string, email: string): boolean {
  if (script.app !== app) {
    return false;
  }
  if (script.status === 'inactive') {
    return false;
  }
  if (script.status === 'testing' && !(email.endsWith('trilogy.com') || email.endsWith('devfactory.com'))) {
    return false;
  }
  const url = window.location.href;
  for (const pattern of script.urlPatterns) {
    if (url.match(pattern)) {
      return true;
    }
  }
  return false;
}
